/**
 * Props for anchors that should open in a new browser tab.
 * Skips same-document hash links and mailto/tel/javascript schemes.
 *
 * @param {string | undefined | null} href
 * @returns {{ target?: string; rel?: string }}
 */
export function newTabLinkProps(href) {
	if (href == null) return {};
	const h = String(href).trim();
	if (!h) return {};
	const lower = h.toLowerCase();
	if (h.startsWith("#")) return {};
	if (lower.startsWith("mailto:") || lower.startsWith("tel:")) return {};
	if (lower.startsWith("javascript:")) return {};
	if (lower.startsWith("http://") || lower.startsWith("https://") || h.startsWith("//")) {
		return { target: "_blank", rel: "noopener noreferrer" };
	}
	if (h.startsWith("/")) {
		return { target: "_blank", rel: "noopener noreferrer" };
	}
	return {};
}
